module.exports = __webpack_public_path__ + "img/Meet.99940dad.svg";